<template>
  <template v-if="!isDfprebook">
    <el-affix :offset="0">
      <Nav />
    </el-affix>
  </template>
  <div :class="{ w1900: !isDfprebook }">
    <router-view></router-view>
    <Footer v-if="!isDfprebook" />
  </div>
</template>

<script>
import Nav from './components/Nav.vue'
import Footer from './components/footer.vue'
export default {
  name: 'App',
  components: {
    Nav,Footer
  },
  computed: {
    isDfprebook() {
      return ['Dfprebook', 'Ebprebook'].includes(this.$route.name)
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
*{
  margin: 0;
  padding: 0;
}
</style>
